// TODO: check if "../../src/views/Article/" works instead of "../../src/views/Article/Article.jsx"
// TODO: shorten component key from component---src-views-article-article-jsx to "Article"
export const asyncComponents = {
  'component---src-views-article-article-jsx': () =>
    import(
      '../../../src/views/Article/Article.jsx'
      /* webpackChunkName: "component---src-views-article-article-jsx" */
    ),
  'component---src-views-author-author-jsx': () =>
    import(
      '../../../src/views/Author/Author.jsx'
      /* webpackChunkName: "component---src-views-author-author-jsx" */
    ),
  'component---src-views-consent-management-consent-management-jsx': () =>
    import(
      '../../../src/views/ConsentManagement/ConsentManagement.jsx'
      /* webpackChunkName: "component---src-views-consent-management-consent-management-jsx" */
    ),
  'component---src-views-error-404-error-404-jsx': () =>
    import(
      '../../../src/views/Error404/Error404.jsx'
      /* webpackChunkName: "component---src-views-error-404-error-404-jsx" */
    ),
  'component---src-views-homepage-homepage-jsx': () =>
    import(
      '../../../src/views/Homepage/Homepage.jsx'
      /* webpackChunkName: "component---src-views-homepage-homepage-jsx" */
    ),
  'component---src-views-hub-page-hub-page-jsx': () =>
    import(
      '../../../src/views/HubPage/HubPage.jsx'
      /* webpackChunkName: "component---src-views-hub-page-hub-page-jsx" */
    ),
  'component---src-views-newsletter-newsletter-jsx': () =>
    import(
      '../../../src/views/Newsletter/Newsletter.jsx'
      /* webpackChunkName: "component---src-views-newsletter-newsletter-jsx" */
    ),
  'component---src-views-page-page-jsx': () =>
    import(
      '../../../src/views/Page/Page.jsx'
      /* webpackChunkName: "component---src-views-page-page-jsx" */
    ),
  'component---src-views-photo-gallery-photo-gallery-jsx': () =>
    import(
      '../../../src/views/PhotoGallery/PhotoGallery.jsx'
      /* webpackChunkName: "component---src-views-photo-gallery-photo-gallery-jsx" */
    ),
  'component---src-views-photographer-photographer-jsx': () =>
    import(
      '../../../src/views/Photographer/Photographer.jsx'
      /* webpackChunkName: "component---src-views-photographer-photographer-jsx" */
    ),
  'component---src-views-pod-index-pod-index-jsx': () =>
    import(
      '../../../src/views/PodIndex/PodIndex.jsx'
      /* webpackChunkName: "component---src-views-pod-index-pod-index-jsx" */
    ),
  'component---src-views-search-search-jsx': () =>
    import(
      '../../../src/views/Search/Search.jsx'
      /* webpackChunkName: "component---src-views-search-search-jsx" */
    ),
  'component---src-views-show-show-jsx': () =>
    import(
      '../../../src/views/Show/Show.jsx'
      /* webpackChunkName: "component---src-views-show-show-jsx" */
    ),
  'component---src-views-subscribe-page-subscribe-page-jsx': () =>
    import(
      '../../../src/views/SubscribePage/SubscribePage.jsx'
      /* webpackChunkName: "component---src-views-subscribe-page-subscribe-page-jsx" */
    ),
  'component---src-views-taxonomy-taxonomy-jsx': () =>
    import(
      '../../../src/views/Taxonomy/Taxonomy.jsx'
      /* webpackChunkName: "component---src-views-taxonomy-taxonomy-jsx" */
    ),
  'component---src-views-television-schedule-television-schedule-jsx': () =>
    import(
      '../../../src/views/TelevisionSchedule/TelevisionSchedule.jsx'
      /* webpackChunkName: "component---src-views-television-schedule-television-schedule-jsx" */
    ),
  'component---src-views-vertical-slideshow-gallery-vertical-slideshow-gallery-jsx':
    () =>
      import(
        '../../../src/views/VerticalSlideshowGallery/VerticalSlideshowGallery.jsx'
        /* webpackChunkName: "component---src-views-vertical-slideshow-gallery-vertical-slideshow-gallery-jsx" */
      )
};
